import consumer from "./consumer"


$(document).ready(function() {

  const element = document.getElementById('room-jefe-jueces-id');
  const room_id = element ? element.getAttribute('data-jefe-jueces-id') : '';



  if (room_id != '' ){
    consumer.subscriptions.create({channel: "JefejuecesChannel", room:room_id},{ 
      connected() {
        // Called when the subscription is ready for use on the server
        console.log("Conectado al Jefejueces channel: " + room_id)
        
      },

      disconnected() {
        // Called when the subscription has been terminated by the server
        console.log("Desconetado del channel de Jefejueces...")
      },

      received(data) {
        // Called when there's incoming data on the websocket for this channel
        
        //var iframe = document.getElementById('iframe_jefejueces');
        //iframe.src = iframe.src; // Recarga el iframe estableciendo su src al mismo valor
        //console.log("solicitud de recargar el iframe jefejueces...")

        var datajson = JSON.parse(data);

        if (datajson["mensaje"] == "admin_tiebreak"){
          $("#session_mensaje").val("admin_tiebreak");
        }


        if (datajson["data"] == "puntos_jj") {
          console.log("Entro al if: " );
          if ($('#modal_puntos').is(':visible')) {
            $("#hay_actualizacion").html("si");

          } else {
            console.log("Entro al else: " );
            $("#btn_actualizar_pagina").click();
          }
        }


        if (datajson["data"] == "nuevo_heat") {
          $("#nuevo_heat_heat_id").val(datajson["heat_id"])
          $("#btn_ir_nuevo_heat").click();
        }

        

      }
    });

  }
    
});

